/*
Module Name :      Loader
File Name   :      loader.jsx
Project     :      OrasiMedaia.com
Copyright (c)      peafowl.inc
author      :     chandrasekhar
author      :
license     :
version     :      0.0.12 // written by  for present.
Created on  :      4th January 2023
Last modified on:  12th January 2023
Description :      
Organisation:      Peafowl inc.
*/

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';





const TableLoader = () => {
    const navigate = useNavigate();
   

    return (

        <>
            <div className="table-preloader">
                <div className="orasi-preloader">
                    <img src={"https://d2aif2zmoi437u.cloudfront.net/orasi/common/images/preloader.png"} />
                </div>
            </div>

        </>
    );
};


export default TableLoader;



